<template>
  <div class="page-main">
    <e-tabs :list="this.$constant.tabListAccount()" isJump />
    <el-button class="m-b-10" type="success" size="mini" @click="itemAdd">新增岗位</el-button>

    <!-- 表格 -->
    <vxe-grid
      size="mini"
      :loading="loading"
      :data="tableDataMain"
      :columns="tableColumn"
      :height="this.$util.getViewHeight() - 36 - 187"
    >
      <!-- slot_default -->
      <template #default_operate="{ row }">
        <template v-if="row.id !== 1">
          <el-link type="success" @click="itemDetail(row)">权限分配</el-link>
          <el-link type="primary" @click="itemEdit(row)">编辑</el-link>
          <el-link type="danger" @click="itemDelete(row)">删除</el-link>
        </template>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-增改岗位 -->
    <PopupRole
      v-if="isShowPopupRole"
      :show.sync="isShowPopupRole"
      :data.sync="itemObj"
      @success="getListData"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupRole: () => import('./popup-role')
  },
  data() {
    return {
      loading: true,

      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        { field: 'name', title: '岗位名称' },
        { field: 'remark', title: '岗位备注' },
        { field: 'created', width: 180, title: '创建时间' },
        {
          field: 'is_able_change',
          title: '岗位名字能否编辑',
          titleHelp: {
            message:
              '岗位名字固定不能编辑，用于销售开单等页面下拉筛选！\n(无论是否，权限都可以正常编辑设置)'
          },
          formatter: ({ cellValue }) => {
            if (cellValue == true) {
              return '是'
            } else {
              return '否'
            }
          }
        },
        { title: '操作', width: 160, slots: { default: 'default_operate' } }
      ],
      tableDataMain: [],
      pageOptions: {
        ...this.$constant.page
      },
      isShowPopupRole: false,
      itemDefault: {
        id: '',
        name: '',
        remark: '',
        is_able_change: false
      },
      itemObj: {}
    }
  },
  mounted() {
    this.initItemObj()
    this.getListData()
  },
  methods: {
    // 初始化itemObj
    initItemObj() {
      this.itemObj = this.$util.deepCopy(this.itemDefault)
    },
    // 获取数据列表
    getListData() {
      this.loading = true
      this.$api({
        method: 'get',
        url: '/admin/role/getRoleListPageVue',
        params: {
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize
        }
      })
        .then((res) => {
          this.tableDataMain = res.data.page.list
          this.pageOptions.pageSize = res.data.page.pageSize
          this.pageOptions.total = res.data.page.totalRow
          this.pageOptions.currentPage = res.data.page.pageNumber
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 项-新增
    itemAdd() {
      this.isShowPopupRole = true
      this.initItemObj()
    },
    // 项-详情
    itemDetail(row) {
      this.$router.push({ path: '/system/role/detail', query: { id: row.id } })
    },
    // 项-编辑
    itemEdit(row) {
      this.isShowPopupRole = true
      this.itemObj = this.$util.deepCopy(row)
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('您确认要删除该数据?', '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/role/deleteVue',
            params: {
              id: row.id
            }
          }).then((res) => {
            if (res.data.state === 'ok') {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
